export default __webpack_public_path__ + "03217b1849f328a8d1b1f796056fef77.png";